"use strict";

exports.__esModule = true;
exports.Toggle = exports.Tabs = exports.Slideover = exports.Popover = exports.Modal = exports.Dropdown = exports.ColorPreview = exports.Autosave = exports.Alert = void 0;
exports.transition = n;
var _stimulus = require("@hotwired/stimulus");
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
var x = Object.defineProperty;
var V = function V(t, s, e) {
  return s in t ? x(t, s, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : t[s] = e;
};
var i = function i(t, s, e) {
  return V(t, _typeof(s) != "symbol" ? s + "" : s, e);
};
function n(_x, _x2) {
  return _n.apply(this, arguments);
}
function _n() {
  _n = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(t, s) {
    var e,
      _args = arguments;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          e = _args.length > 2 && _args[2] !== undefined ? _args[2] : {};
          if (!s) {
            _context.n = 2;
            break;
          }
          _context.n = 1;
          return T(t, e);
        case 1:
          _context.n = 3;
          break;
        case 2:
          _context.n = 3;
          return b(t, e);
        case 3:
          return _context.a(2);
      }
    }, _callee);
  }));
  return _n.apply(this, arguments);
}
function T(_x3) {
  return _T.apply(this, arguments);
}
function _T() {
  _T = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(t) {
    var s,
      _C,
      e,
      a,
      o,
      r,
      _args2 = arguments;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          s = _args2.length > 1 && _args2[1] !== undefined ? _args2[1] : {};
          _C = C("Enter", t, s), e = _C.transitionClasses, a = _C.fromClasses, o = _C.toClasses, r = _C.toggleClass;
          return _context2.a(2, v(t, {
            firstFrame: function firstFrame() {
              var _t$classList, _t$classList2, _t$classList3, _t$classList4;
              (_t$classList = t.classList).add.apply(_t$classList, _toConsumableArray(e.split(" "))), (_t$classList2 = t.classList).add.apply(_t$classList2, _toConsumableArray(a.split(" "))), (_t$classList3 = t.classList).remove.apply(_t$classList3, _toConsumableArray(o.split(" "))), (_t$classList4 = t.classList).remove.apply(_t$classList4, _toConsumableArray(r.split(" ")));
            },
            secondFrame: function secondFrame() {
              var _t$classList5, _t$classList6;
              (_t$classList5 = t.classList).remove.apply(_t$classList5, _toConsumableArray(a.split(" "))), (_t$classList6 = t.classList).add.apply(_t$classList6, _toConsumableArray(o.split(" ")));
            },
            ending: function ending() {
              var _t$classList7;
              (_t$classList7 = t.classList).remove.apply(_t$classList7, _toConsumableArray(e.split(" ")));
            }
          }));
      }
    }, _callee2);
  }));
  return _T.apply(this, arguments);
}
function b(_x4) {
  return _b.apply(this, arguments);
}
function _b() {
  _b = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(t) {
    var s,
      _C2,
      e,
      a,
      o,
      r,
      _args3 = arguments;
    return _regenerator().w(function (_context3) {
      while (1) switch (_context3.n) {
        case 0:
          s = _args3.length > 1 && _args3[1] !== undefined ? _args3[1] : {};
          _C2 = C("Leave", t, s), e = _C2.transitionClasses, a = _C2.fromClasses, o = _C2.toClasses, r = _C2.toggleClass;
          return _context3.a(2, v(t, {
            firstFrame: function firstFrame() {
              var _t$classList8, _t$classList9, _t$classList0;
              (_t$classList8 = t.classList).add.apply(_t$classList8, _toConsumableArray(a.split(" "))), (_t$classList9 = t.classList).remove.apply(_t$classList9, _toConsumableArray(o.split(" "))), (_t$classList0 = t.classList).add.apply(_t$classList0, _toConsumableArray(e.split(" ")));
            },
            secondFrame: function secondFrame() {
              var _t$classList1, _t$classList10;
              (_t$classList1 = t.classList).remove.apply(_t$classList1, _toConsumableArray(a.split(" "))), (_t$classList10 = t.classList).add.apply(_t$classList10, _toConsumableArray(o.split(" ")));
            },
            ending: function ending() {
              var _t$classList11, _t$classList12;
              (_t$classList11 = t.classList).remove.apply(_t$classList11, _toConsumableArray(e.split(" "))), (_t$classList12 = t.classList).add.apply(_t$classList12, _toConsumableArray(r.split(" ")));
            }
          }));
      }
    }, _callee3);
  }));
  return _b.apply(this, arguments);
}
function C(t, s, e) {
  return {
    transitionClasses: s.dataset["transition".concat(t)] || e[t.toLowerCase()] || t.toLowerCase(),
    fromClasses: s.dataset["transition".concat(t, "From")] || e["".concat(t.toLowerCase(), "From")] || "".concat(t.toLowerCase(), "-from"),
    toClasses: s.dataset["transition".concat(t, "To")] || e["".concat(t.toLowerCase(), "To")] || "".concat(t.toLowerCase(), "-to"),
    toggleClass: s.dataset.toggleClass || e.toggleClass || e.toggle || "hidden"
  };
}
function L(t) {
  t._stimulus_transition = {
    timeout: null,
    interrupted: !1
  };
}
function I(t) {
  t._stimulus_transition && t._stimulus_transition.interrupt && t._stimulus_transition.interrupt();
}
function v(t, s) {
  t._stimulus_transition && I(t);
  var e, a, o;
  return L(t), t._stimulus_transition.cleanup = function () {
    a || s.firstFrame(), o || s.secondFrame(), s.ending(), t._stimulus_transition = null;
  }, t._stimulus_transition.interrupt = function () {
    e = !0, t._stimulus_transition.timeout && clearTimeout(t._stimulus_transition.timeout), t._stimulus_transition.cleanup();
  }, new Promise(function (r) {
    e || requestAnimationFrame(function () {
      e || (s.firstFrame(), a = !0, requestAnimationFrame(function () {
        e || (s.secondFrame(), o = !0, t._stimulus_transition && (t._stimulus_transition.timeout = setTimeout(function () {
          if (e) {
            r();
            return;
          }
          t._stimulus_transition.cleanup(), r();
        }, w(t))));
      }));
    });
  });
}
function w(t) {
  var s = Number(getComputedStyle(t).transitionDuration.replace(/,.*/, "").replace("s", "")) * 1e3,
    e = Number(getComputedStyle(t).transitionDelay.replace(/,.*/, "").replace("s", "")) * 1e3;
  return s === 0 && (s = Number(getComputedStyle(t).animationDuration.replace("s", "")) * 1e3), s + e;
}
var g = exports.Alert = /*#__PURE__*/function (_y) {
  function g() {
    _classCallCheck(this, g);
    return _callSuper(this, g, arguments);
  }
  _inherits(g, _y);
  return _createClass(g, [{
    key: "connect",
    value: function connect() {
      var _this = this;
      setTimeout(function () {
        T(_this.element);
      }, this.showDelayValue), this.hasDismissAfterValue && setTimeout(function () {
        _this.close();
      }, this.dismissAfterValue);
    }
  }, {
    key: "close",
    value: function close() {
      var _this2 = this;
      b(this.element).then(function () {
        _this2.element.remove();
      });
    }
  }]);
}(_stimulus.Controller);
i(g, "values", {
  dismissAfter: Number,
  showDelay: {
    type: Number,
    default: 0
  }
});
var h = exports.Autosave = /*#__PURE__*/function (_A) {
  function h() {
    _classCallCheck(this, h);
    return _callSuper(this, h, arguments);
  }
  _inherits(h, _A);
  return _createClass(h, [{
    key: "connect",
    value: function connect() {
      this.timeout = null;
    }
  }, {
    key: "save",
    value: function save() {
      var _this3 = this;
      clearTimeout(this.timeout), this.timeout = setTimeout(function () {
        _this3.statusTarget.textContent = _this3.submittingTextValue, _this3.formTarget.requestSubmit();
      }, this.submitDurationValue);
    }
  }, {
    key: "success",
    value: function success() {
      this.setStatus(this.successTextValue);
    }
  }, {
    key: "error",
    value: function error() {
      this.setStatus(this.errorTextValue);
    }
  }, {
    key: "setStatus",
    value: function setStatus(t) {
      var _this4 = this;
      this.statusTarget.textContent = t, this.timeout = setTimeout(function () {
        _this4.statusTarget.textContent = "";
      }, this.statusDurationValue);
    }
  }]);
}(_stimulus.Controller);
i(h, "targets", ["form", "status"]), i(h, "values", {
  submitDuration: {
    type: Number,
    default: 1e3
  },
  statusDuration: {
    type: Number,
    default: 2e3
  },
  submittingText: {
    type: String,
    default: "Saving..."
  },
  successText: {
    type: String,
    default: "Saved!"
  },
  errorText: {
    type: String,
    default: "Unable to save."
  }
});
var c = exports.ColorPreview = /*#__PURE__*/function (_ref) {
  function c() {
    _classCallCheck(this, c);
    return _callSuper(this, c, arguments);
  }
  _inherits(c, _ref);
  return _createClass(c, [{
    key: "update",
    value: function update() {
      this.preview = this.colorTarget.value;
    }
  }, {
    key: "preview",
    set: function set(t) {
      this.previewTarget.style[this.styleValue] = t;
      var s = this._getContrastYIQ(t);
      this.styleValue === "color" ? this.previewTarget.style.backgroundColor = s : this.previewTarget.style.color = s;
    }
  }, {
    key: "_getContrastYIQ",
    value: function _getContrastYIQ(t) {
      t = t.replace("#", "");
      var s = 128,
        e = parseInt(t.substr(0, 2), 16),
        a = parseInt(t.substr(2, 2), 16),
        o = parseInt(t.substr(4, 2), 16);
      return (e * 299 + a * 587 + o * 114) / 1e3 >= s ? "#000" : "#fff";
    }
  }]);
}(_stimulus.Controller);
i(c, "targets", ["preview", "color"]), i(c, "values", {
  style: {
    type: String,
    default: "backgroundColor"
  }
});
var l = exports.Dropdown = /*#__PURE__*/function (_D) {
  function l() {
    _classCallCheck(this, l);
    return _callSuper(this, l, arguments);
  }
  _inherits(l, _D);
  return _createClass(l, [{
    key: "connect",
    value: function connect() {
      this.boundBeforeCache = this.beforeCache.bind(this), document.addEventListener("turbo:before-cache", this.boundBeforeCache);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      document.removeEventListener("turbo:before-cache", this.boundBeforeCache);
    }
  }, {
    key: "openValueChanged",
    value: function openValueChanged() {
      n(this.menuTarget, this.openValue, this.transitionOptions), this.openValue === !0 && this.hasMenuItemTarget && this.menuItemTargets[0].focus();
    }
  }, {
    key: "show",
    value: function show() {
      this.openValue = !0;
    }
  }, {
    key: "close",
    value: function close() {
      this.openValue = !1;
    }
  }, {
    key: "hide",
    value: function hide(t) {
      this.closeOnClickOutsideValue && t.target.nodeType && this.element.contains(t.target) === !1 && this.openValue && (this.openValue = !1), this.closeOnEscapeValue && t.key === "Escape" && this.openValue && (this.openValue = !1);
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.openValue = !this.openValue;
    }
  }, {
    key: "nextItem",
    value: function nextItem(t) {
      t.preventDefault(), this.menuItemTargets[this.nextIndex].focus();
    }
  }, {
    key: "previousItem",
    value: function previousItem(t) {
      t.preventDefault(), this.menuItemTargets[this.previousIndex].focus();
    }
  }, {
    key: "currentItemIndex",
    get: function get() {
      return this.menuItemTargets.indexOf(document.activeElement);
    }
  }, {
    key: "nextIndex",
    get: function get() {
      return Math.min(this.currentItemIndex + 1, this.menuItemTargets.length - 1);
    }
  }, {
    key: "previousIndex",
    get: function get() {
      return Math.max(this.currentItemIndex - 1, 0);
    }
  }, {
    key: "transitionOptions",
    get: function get() {
      return {
        enter: this.hasEnterClass ? this.enterClasses.join(" ") : "transition ease-out duration-100",
        enterFrom: this.hasEnterFromClass ? this.enterFromClasses.join(" ") : "transform opacity-0 scale-95",
        enterTo: this.hasEnterToClass ? this.enterToClasses.join(" ") : "transform opacity-100 scale-100",
        leave: this.hasLeaveClass ? this.leaveClasses.join(" ") : "transition ease-in duration-75",
        leaveFrom: this.hasLeaveFromClass ? this.leaveFromClasses.join(" ") : "transform opacity-100 scale-100",
        leaveTo: this.hasLeaveToClass ? this.leaveToClasses.join(" ") : "transform opacity-0 scale-95",
        toggleClass: this.hasToggleClass ? this.toggleClasses.join(" ") : "hidden"
      };
    }
  }, {
    key: "beforeCache",
    value: function beforeCache() {
      this.openValue = !1, this.menuTarget.classList.add(this.transitionOptions.toggleClass);
    }
  }]);
}(_stimulus.Controller);
i(l, "targets", ["menu", "button", "menuItem"]), i(l, "values", {
  open: {
    type: Boolean,
    default: !1
  },
  closeOnEscape: {
    type: Boolean,
    default: !0
  },
  closeOnClickOutside: {
    type: Boolean,
    default: !0
  }
}), i(l, "classes", ["enter", "enterFrom", "enterTo", "leave", "leaveFrom", "leaveTo", "toggle"]);
var d = exports.Modal = /*#__PURE__*/function (_F) {
  function d() {
    _classCallCheck(this, d);
    return _callSuper(this, d, arguments);
  }
  _inherits(d, _F);
  return _createClass(d, [{
    key: "connect",
    value: function connect() {
      this.openValue && this.open(), this.boundBeforeCache = this.beforeCache.bind(this), document.addEventListener("turbo:before-cache", this.boundBeforeCache);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      document.removeEventListener("turbo:before-cache", this.boundBeforeCache);
    }
  }, {
    key: "open",
    value: function open() {
      this.dialogTarget.showModal();
    }
  }, {
    key: "close",
    value: function close() {
      var _this5 = this;
      this.dialogTarget.setAttribute("closing", ""), Promise.all(this.dialogTarget.getAnimations().map(function (t) {
        return t.finished;
      })).then(function () {
        _this5.dialogTarget.removeAttribute("closing"), _this5.dialogTarget.close();
      });
    }
  }, {
    key: "backdropClose",
    value: function backdropClose(t) {
      t.target.nodeName == "DIALOG" && this.close();
    }
  }, {
    key: "show",
    value: function show() {
      this.dialogTarget.show();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.close();
    }
  }, {
    key: "beforeCache",
    value: function beforeCache() {
      this.close();
    }
  }]);
}(_stimulus.Controller);
i(d, "targets", ["dialog"]), i(d, "values", {
  open: Boolean
});
var f = exports.Popover = /*#__PURE__*/function (_B) {
  function f() {
    _classCallCheck(this, f);
    return _callSuper(this, f, arguments);
  }
  _inherits(f, _B);
  return _createClass(f, [{
    key: "openValueChanged",
    value: function openValueChanged() {
      n(this.contentTarget, this.openValue), this.shouldAutoDismiss && this.scheduleDismissal();
    }
  }, {
    key: "show",
    value: function show(t) {
      this.shouldAutoDismiss && this.scheduleDismissal(), this.openValue = !0;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.openValue = !1;
    }
  }, {
    key: "toggle",
    value: function toggle() {
      this.openValue = !this.openValue;
    }
  }, {
    key: "shouldAutoDismiss",
    get: function get() {
      return this.openValue && this.hasDismissAfterValue;
    }
  }, {
    key: "scheduleDismissal",
    value: function scheduleDismissal() {
      var _this6 = this;
      this.hasDismissAfterValue && (this.cancelDismissal(), this.timeoutId = setTimeout(function () {
        _this6.hide(), _this6.timeoutId = void 0;
      }, this.dismissAfterValue));
    }
  }, {
    key: "cancelDismissal",
    value: function cancelDismissal() {
      typeof this.timeoutId == "number" && (clearTimeout(this.timeoutId), this.timeoutId = void 0);
    }
  }]);
}(_stimulus.Controller);
i(f, "targets", ["content"]), i(f, "values", {
  dismissAfter: Number,
  open: {
    type: Boolean,
    default: !1
  }
});
var m = exports.Slideover = /*#__PURE__*/function (_E) {
  function m() {
    _classCallCheck(this, m);
    return _callSuper(this, m, arguments);
  }
  _inherits(m, _E);
  return _createClass(m, [{
    key: "connect",
    value: function connect() {
      this.openValue && this.open(), this.boundBeforeCache = this.beforeCache, document.addEventListener("turbo:before-cache", this.boundBeforeCache);
    }
  }, {
    key: "disconnect",
    value: function disconnect() {
      document.removeEventListener("turbo:before-cache", this.boundBeforeCache);
    }
  }, {
    key: "open",
    value: function open() {
      this.dialogTarget.showModal();
    }
  }, {
    key: "close",
    value: function close() {
      var _this7 = this;
      this.dialogTarget.setAttribute("closing", ""), Promise.all(this.dialogTarget.getAnimations().map(function (t) {
        return t.finished;
      })).then(function () {
        _this7.dialogTarget.removeAttribute("closing"), _this7.dialogTarget.close();
      });
    }
  }, {
    key: "backdropClose",
    value: function backdropClose(t) {
      t.target.nodeName == "DIALOG" && this.close();
    }
  }, {
    key: "show",
    value: function show() {
      this.open();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.close();
    }
  }, {
    key: "beforeCache",
    value: function beforeCache() {
      this.close();
    }
  }]);
}(_stimulus.Controller);
i(m, "targets", ["dialog"]), i(m, "values", {
  open: Boolean
});
var u = exports.Tabs = /*#__PURE__*/function (_S) {
  function u() {
    _classCallCheck(this, u);
    return _callSuper(this, u, arguments);
  }
  _inherits(u, _S);
  return _createClass(u, [{
    key: "initialize",
    value: function initialize() {
      var _this8 = this;
      this.updateAnchorValue && this.anchor && (this.indexValue = this.tabTargets.findIndex(function (t) {
        return t.id === _this8.anchor;
      }));
    }
  }, {
    key: "connect",
    value: function connect() {
      this.showTab();
    }
  }, {
    key: "change",
    value: function change(t) {
      t.currentTarget.tagName === "SELECT" ? this.indexValue = t.currentTarget.selectedIndex : t.currentTarget.dataset.index ? this.indexValue = t.currentTarget.dataset.index : t.currentTarget.dataset.id ? this.indexValue = this.tabTargets.findIndex(function (s) {
        return s.id == t.currentTarget.dataset.id;
      }) : this.indexValue = this.tabTargets.indexOf(t.currentTarget);
    }
  }, {
    key: "nextTab",
    value: function nextTab() {
      this.indexValue = Math.min(this.indexValue + 1, this.tabsCount - 1);
    }
  }, {
    key: "previousTab",
    value: function previousTab() {
      this.indexValue = Math.max(this.indexValue - 1, 0);
    }
  }, {
    key: "firstTab",
    value: function firstTab() {
      this.indexValue = 0;
    }
  }, {
    key: "lastTab",
    value: function lastTab() {
      this.indexValue = this.tabsCount - 1;
    }
  }, {
    key: "indexValueChanged",
    value: function indexValueChanged() {
      if (this.showTab(), this.dispatch("tab-change", {
        target: this.tabTargets[this.indexValue],
        detail: {
          activeIndex: this.indexValue
        }
      }), this.updateAnchorValue) {
        var t = this.tabTargets[this.indexValue].id;
        if (this.scrollToAnchorValue) location.hash = t;else {
          var e = window.location.href.split("#")[0] + "#" + t;
          (typeof Turbo === "undefined" ? "undefined" : _typeof(Turbo)) < "u" ? Turbo.navigator.history.replace(new URL(e)) : history.replaceState({}, document.title, e);
        }
      }
    }
  }, {
    key: "showTab",
    value: function showTab() {
      var _this9 = this;
      this.panelTargets.forEach(function (t, s) {
        var _e$classList, _e$classList2, _e$classList3, _e$classList4;
        var e = _this9.tabTargets[s];
        s === _this9.indexValue ? (t.classList.remove("hidden"), e.ariaSelected = "true", e.dataset.active = !0, _this9.hasInactiveTabClass && e !== null && e !== void 0 && (_e$classList = e.classList) !== null && _e$classList !== void 0 && _e$classList.remove.apply(_e$classList, _toConsumableArray(_this9.inactiveTabClasses)), _this9.hasActiveTabClass && (e === null || e === void 0 || (_e$classList2 = e.classList) === null || _e$classList2 === void 0 ? void 0 : _e$classList2.add.apply(_e$classList2, _toConsumableArray(_this9.activeTabClasses)))) : (t.classList.add("hidden"), e.ariaSelected = null, delete e.dataset.active, _this9.hasActiveTabClass && e !== null && e !== void 0 && (_e$classList3 = e.classList) !== null && _e$classList3 !== void 0 && _e$classList3.remove.apply(_e$classList3, _toConsumableArray(_this9.activeTabClasses)), _this9.hasInactiveTabClass && (e === null || e === void 0 || (_e$classList4 = e.classList) === null || _e$classList4 === void 0 ? void 0 : _e$classList4.add.apply(_e$classList4, _toConsumableArray(_this9.inactiveTabClasses))));
      }), this.hasSelectTarget && (this.selectTarget.selectedIndex = this.indexValue), this.scrollActiveTabIntoViewValue && this.scrollToActiveTab();
    }
  }, {
    key: "scrollToActiveTab",
    value: function scrollToActiveTab() {
      var t = this.element.querySelector("[aria-selected]");
      t && t.scrollIntoView({
        inline: "center"
      });
    }
  }, {
    key: "tabsCount",
    get: function get() {
      return this.tabTargets.length;
    }
  }, {
    key: "anchor",
    get: function get() {
      return document.URL.split("#").length > 1 ? document.URL.split("#")[1] : null;
    }
  }]);
}(_stimulus.Controller);
i(u, "classes", ["activeTab", "inactiveTab"]), i(u, "targets", ["tab", "panel", "select"]), i(u, "values", {
  index: 0,
  updateAnchor: Boolean,
  scrollToAnchor: Boolean,
  scrollActiveTabIntoView: Boolean
});
var p = exports.Toggle = /*#__PURE__*/function (_N) {
  function p() {
    _classCallCheck(this, p);
    return _callSuper(this, p, arguments);
  }
  _inherits(p, _N);
  return _createClass(p, [{
    key: "toggle",
    value: function toggle(t) {
      this.openValue = !this.openValue, this.animate();
    }
  }, {
    key: "toggleInput",
    value: function toggleInput(t) {
      this.openValue = t.target.checked, this.animate();
    }
  }, {
    key: "hide",
    value: function hide() {
      this.openValue = !1, this.animate();
    }
  }, {
    key: "show",
    value: function show() {
      this.openValue = !0, this.animate();
    }
  }, {
    key: "animate",
    value: function animate() {
      var _this0 = this;
      this.toggleableTargets.forEach(function (t) {
        n(t, _this0.openValue);
      });
    }
  }]);
}(_stimulus.Controller);
i(p, "targets", ["toggleable"]), i(p, "values", {
  open: {
    type: Boolean,
    default: !1
  }
});